import React from 'react';
import logo from '../../assets/images/logo-outline.png';
import waveLogo from '../../assets/images/logo-color.png';

interface LogoProps {
  theme: 'light' | 'dark';
  title?: string;
  onClick?: () => void;
  className?: string;
}

/**
 * Reusable Logo Component
 * Used in Navbar (clickable) and Auth (non-clickable)
 */
const Logo: React.FC<LogoProps> = ({
  theme,
  title = 'WaveBudget',
  onClick,
  className = '',
}) => {
  return (
    <div 
      className={`inline-flex items-center gap-3 user-select-none leading-none h-10 ${onClick ? 'cursor-pointer hover:-translate-y-0.5 active:translate-y-0 transition-transform' : ''} ${className}`}
      onClick={onClick}
    >
      <img
        src={theme === 'light' ? logo : waveLogo}
        alt="WaveBudget Logo"
        className="w-7 h-7 object-contain flex-shrink-0 md:w-6 md:h-6"
      />
      <span className={`text-[1.1rem] font-bold leading-none whitespace-nowrap md:text-[1rem] sm:text-[0.95rem] ${
        theme === 'dark'
          ? 'text-white'
          : 'bg-gradient-to-br from-primary to-[#0051D5] bg-clip-text text-transparent'
      }`}>
        {title}
      </span>
    </div>
  );
};

export default Logo;
